import { List } from '@material-ui/core';
import { Children, ClassAttributes, createElement, ReactChild } from 'react';

type Props = ClassAttributes<HTMLElement> & {
  className?: string;
  children: ReactChild | ReactChild[];
};

const FileList = ({ className, children }: Props) => <List className={className}>{Children.toArray(children)}</List>;

export default FileList;
